import Api from '@/services/Index'

const getAllById = (examId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/exam/questions/by-exam/'+examId)
}

const store = (formData, examId)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/exam/questions/by-exam/'+examId, formData)
}

const put = (formData, examQuestionId)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.put(`/exam/questions/${examQuestionId}`, formData)
}

const del = (examQuestionId)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.delete('/exam/questions/'+examQuestionId)
}

const getStudentsAndScores = (examId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/exam/questions/score-entry/'+examId)
}

const updateStudentScores = (formData, examId)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/exam/questions/score-entry/'+examId, formData)
}

const downloadTemplate = async (examId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/exam/questions/score-template/'+examId, { responseType: 'arraybuffer' })
}

const uploadTemplate = (formData, examId)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/exam/questions/score-template/'+examId+'/import/', formData)
}

export default {
    getAllById,
    store,
    del,
    put,
    getStudentsAndScores,
    updateStudentScores,
    downloadTemplate,
    uploadTemplate
}
